import { toast } from "@provider/toast";

export async function openBrowser(url: string, redirectUrl: string): Promise<Window | null> {
  const newWindow = window.open(url, "_blank", "noopener,noreferrer");
  if (!newWindow) {
    toast.show("Sta popup toe in rechterbovenhoek van je scherm");
  }
  return window;
}

export function closeBrowser(window: Window | null) {
  window?.close?.();
}
